/** Modalidade comercial de um vendedor que específica a forma de atualização e vínculo com a empresa */
export enum RepresentanteModalidadeComercial {
    REPRESENTANTE = 1,
    VENDA_DIRETA = 2
}

/** Valor de uma modalidade comercial */
export interface RepresentanteModalidadeComercialValue {
    id: RepresentanteModalidadeComercial,
    nome: string;
    descricao: string;
    backgroundColor: string;
    color: string;
}

/* Representante */
export const REPRESENTANTE_MODALIDADE_COMERCIAL_REPRESENTANTE: RepresentanteModalidadeComercialValue = {
    id: RepresentanteModalidadeComercial.REPRESENTANTE,
    nome: 'Representante',
    descricao: 'Os clientes são atendidos e as vendas são realizadas por um representante comercial',
    backgroundColor: '#d0e3f7',
    color: '#237dd8'
}

/* Venda Direta */
export const REPRESENTANTE_MODALIDADE_COMERCIAL_VENDA_DIRETA: RepresentanteModalidadeComercialValue = {
    id: RepresentanteModalidadeComercial.VENDA_DIRETA,
    nome: 'Venda Direta',
    descricao: 'Os clientes são atendidos e as vendas são realizadas diretamente pela sua equipe comercial interna',
    backgroundColor: '#e8d1fc',
    color: '#ab59f5'
}

/** Modalidades Comerciais */
export const REPRESENTANTES_MODALIDES_COMERCIAIS: RepresentanteModalidadeComercialValue[] = [
    REPRESENTANTE_MODALIDADE_COMERCIAL_REPRESENTANTE,
    REPRESENTANTE_MODALIDADE_COMERCIAL_VENDA_DIRETA
]

/** Obtem a modalidade comercial */
export function getRepresentanteModalidadeComercial(modalidade: number): RepresentanteModalidadeComercialValue {
    return REPRESENTANTES_MODALIDES_COMERCIAIS.find(modalidadeFilter => modalidadeFilter.id === modalidade);
}

/** Verifica se a modalidade comercial é representante */
export function isRepresentanteModalidadeComercialRepresentante(modalidade: number): boolean {
    return modalidade === REPRESENTANTE_MODALIDADE_COMERCIAL_REPRESENTANTE.id;
}

/** Verifica se a modalidade comercial é venda direta */
export function isRepresentanteModalidadeComercialVendaDireta(modalidade: number): boolean {
    return modalidade === REPRESENTANTE_MODALIDADE_COMERCIAL_VENDA_DIRETA.id;
}
